module.exports = __webpack_public_path__ + "img/spring2.e672d1cf.png";